function hasEvent(session, type) {
  return session.events.some(e => e.type === type);
}

function hasAnyEvent(session, types) {
  return types.some(type => hasEvent(session, type));
}

export function analyzeDiagnostics(session) {
  const issues = [];
  const push = (severity, code, message, evidence = {}) => {
    issues.push({ severity, code, message, evidence });
  };
  const lifecycleStatus = session.lifecycle?.status;

  if (lifecycleStatus === 'idle') {
    return {
      summary: { error: 0, warning: 0, info: 0 },
      issues: [],
    };
  }

  const started = hasEvent(session, 'adstarted');
  const completed = hasAnyEvent(session, ['adcomplete', 'addestroyed']);
  const errored = hasEvent(session, 'aderror');
  const impressions = session.events.filter(e => e.type === 'adimpression').length;
  const quartiles = ['adfirstquartile', 'admidpoint', 'adthirdquartile', 'adcomplete'];
  const quartilesSeen = session.events.filter(e => quartiles.includes(e.type)).map(e => e.type);

  if (!started) {
    push('error', 'ad-not-started', 'Ad never reached adstarted event.');
  }

  if (errored) {
    const firstError = session.events.find(e => e.type === 'aderror');
    push('error', 'ad-error', 'Ad error was reported during playback.', {
      code: firstError?.data?.code,
      message: firstError?.data?.message,
    });
  }

  if (started && !completed && !errored) {
    push('warning', 'unfinished-session', 'Ad started but did not complete or error before session ended.');
  }

  if (started && impressions === 0 && !errored) {
    push('error', 'missing-impression', 'Missing adimpression event after ad start.');
  } else if (impressions > 1) {
    push('warning', 'duplicate-impression', `adimpression fired ${impressions} times.`);
  }

  if (started && quartilesSeen.length === 0 && !errored) {
    push('warning', 'missing-quartiles', 'No quartile progress events were observed.');
  }

  if (started && session.networkLog.length === 0 && !errored) {
    push('warning', 'missing-tracking', 'No tracking network requests were detected.');
  }

  if (session.validationResults?.failed > 0) {
    push('error', 'validation-failed', `${session.validationResults.failed} validation rule(s) failed.`);
  }

  if (issues.length === 0) {
    push('info', 'healthy-session', 'No significant diagnostics issues detected.');
  }

  const summary = {
    error: issues.filter(i => i.severity === 'error').length,
    warning: issues.filter(i => i.severity === 'warning').length,
    info: issues.filter(i => i.severity === 'info').length,
  };

  return { summary, issues };
}
